export const ExamCentersTypes = {
  ALL: 'ALL',
  CODENGO: 'CODENGO',
  DEKRA: 'DEKRA',
  LAPOSTE: 'LAPOSTE',
  POINTCODE: 'POINTCODE',
  SGS: 'SGS',
  EXACODE: 'EXACODE',
  FRANCECODE: 'FRANCECODE',
};

export const ExamCentersColors = {
  [ExamCentersTypes.CODENGO]: '#acc840',
  [ExamCentersTypes.DEKRA]: '#008b4d',
  [ExamCentersTypes.LAPOSTE]: '#fec801',
  [ExamCentersTypes.POINTCODE]: '#1382a3',
  [ExamCentersTypes.SGS]: '#f69138',
  [ExamCentersTypes.EXACODE]: '#ed1651',
  [ExamCentersTypes.FRANCECODE]: '#fb0b0c',
};
